import { useState, useEffect, useRef } from "react";
import "../../styles/transaction.css";
import holding from "../../images/orders/logo.svg";
import filter from "../../images/transaction/filter.svg";
import { IoMdClose } from "react-icons/io";

const AdminTransactionTable = ({
  data,
  selectedType,
  selectedStatus,
  onTypeChange,
  onStatusChange,
  currentPage
}) => {

  return (
    <div className="table-container table-responsive">
      <table className="table_transaction">
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th> Name</th>
            <th>Scheme</th>
            <th>Target Scheme</th>
            <th>Invested By</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((transaction, index) => (
              <tr
                key={index}
                className={`${transaction.trxn_status.toLowerCase()} transaction_row`}
              >
                <td> {(currentPage - 1) * 10 + (index + 1) || "NA"}</td>
                <td>
                  {transaction?.createdAt
                    ? new Date(transaction?.createdAt).toLocaleDateString(
                        "en-GB"
                      )
                    : "NA"}
                </td>
                <td className="white-space-normal">{transaction?.product_long_name || "NA"}</td>
                <td className="white-space-normal">
                  {transaction?.master_scheme?.scheme_name || "NA"}
                </td>
                <td>{transaction.target_product || "NA"}</td>
                <td>{transaction.inv_name || "NA"}</td>
                <td>
                  <span
                    className={`status ${transaction?.status.toLowerCase()}`}
                  >
                    {transaction?.status || "NA"}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr style={{ height: "100px" }}>
              <td colSpan="12" className="no-data-message text-center">
                No transactions found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <style jsx>{`
        .filter-popup {
          position: absolute;
          // background: white;
          padding: 8px;
          // border: 1px solid #dee2e6;
          border-radius: 4px;
          z-index: 1000;
          min-width: 200px;
        }

        .status-filter-popup {
          position: absolute;
          padding: 8px;
          border-radius: 4px;
          z-index: 1000;
          min-width: 200px;
          right: 36px;
        }
        .close-btn-mb {
          margin-bottom: 4px;
        }

        .btn-link {
          color: #6c757d;
          text-decoration: none;
        }

        .btn-link:hover {
          color: #0d6efd;
        }

        .input-group .btn {
          border-left: none;
        }
      `}</style>
    </div>
  );
};

export default AdminTransactionTable;
